"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplementalDataSlug = exports.LoanProductSlugs = void 0;
exports.LoanProductSlugs = {
    AcmeCorpLoanProduct: 'acmeCorpLoanProduct',
    CoitTowerTechnologiesLoanProduct: 'coitTowerTechnologiesLoanProduct',
    EmbarcaderoTechnologiesLoanProduct: 'embarcaderoTechnologiesLoanProduct',
    AirbaseLoanProduct: 'airbaseLoanProduct',
    ArcLoanProduct: 'arcLoanProduct',
    BrightflowLoanProduct: 'brightflowLoanProduct',
    CaptainLoanProduct: 'captainLoanProduct',
    CaratsAndCakeLoanProduct: 'caratsAndCakeLoanProduct',
    CardlessLoanProduct: 'cardlessLoanProduct',
    CherryLoanProduct: 'cherryLoanProduct',
    ClaraLoanProduct: 'claraLoanProduct',
    CoastLoanProduct: 'coastLoanProduct',
    EvenLoanProduct: 'evenLoanProduct',
    FundrLoanProduct: 'fundrLoanProduct',
    ImprintLoanProduct: 'imprintLoanProduct',
    LawMeLoanProduct: 'lawMeLoanProduct',
    MultiplyLoanProduct: 'multiplyLoanProduct',
    MundiExpLoanProduct: 'mundiExpLoanProduct',
    MundiIfpLoanProduct: 'mundiIfpLoanProduct',
    NectarLoanProduct: 'nectarLoanProduct',
    NessLoanProduct: 'nessLoanProduct',
    ParafinLoanProduct: 'parafinLoanProduct',
    ParkerLoanProduct: 'parkerLoanProduct',
    RainLoanProduct: 'rainLoanProduct',
    RampLoanProduct: 'rampLoanProduct',
    RatioLoanProduct: 'ratioLoanProduct',
    TandymLoanProduct: 'tandymLoanProduct',
    ToolboxLoanProduct: 'toolboxLoanProduct',
    TripActionsLoanProduct: 'tripActionsLoanProduct',
    UpsideLoanProduct: 'upsideLoanProduct',
    UsAutoLoanProduct: 'usAutoLoanProduct',
    VayaLoanProduct: 'vayaLoanProduct',
};
var SupplementalDataSlug;
(function (SupplementalDataSlug) {
    SupplementalDataSlug["MundiIntlDebtorData"] = "mundiIntlDebtorData";
})(SupplementalDataSlug = exports.SupplementalDataSlug || (exports.SupplementalDataSlug = {}));
//# sourceMappingURL=LoanProduct.js.map